var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"play-btn",class:{ 'small': _vm.size === 'small' }},[_c('div',{staticClass:"triangle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }